import { Env } from '@stencil/core';
const hostname: string = globalThis.location?.hostname?.toLowerCase();
const baseUrlParts = hostname.split('.');
const hasSubdomain = hostname.split('.').length > 2;
const baseUrlSubdomain = hasSubdomain ? baseUrlParts[0].toLowerCase() : 'www';
const hasOfferDomainPath = globalThis.location?.pathname?.toLowerCase().includes('/offer/');
let envConfig = Env.apiEnv || 'prod';

if (baseUrlParts[0].toLowerCase() === 'www') {
  envConfig = 'prod';
}

const isLocalHost = baseUrlParts[0].toLowerCase() === 'localhost' || envConfig.toLowerCase() === 'local';
let isATC = baseUrlParts.includes('autotrader');
let ATC_BASE_URL = envConfig === 'prod' ? 'https://www.autotrader.com' : 'https://test.autotrader.com';
let KBB_BASE_URL = envConfig === 'prod' ? 'https://www.kbb.com' : 'https://staging.kbb.com';
const CONSUMER_API_PATH: string = '/account-api/consumer';
const NATIVE_APP_EVENT_NAME = 'autotraderMobileApp.webViewLoaded';

if (hostname === 'static.kbb.com') {
  envConfig = isLocalHost ? 'local' : baseUrlSubdomain === 'www' ? 'prod' : 'nonprod';
  const pathConfig = location.pathname.toLowerCase().split('/').includes("nonprod") ? 'nonprod' : 'prod';
  envConfig = pathConfig ? pathConfig.toLowerCase() : envConfig;
}

let API_BASE_URL = `${ATC_BASE_URL}/marketplace`;

const consumerConfigs = {
  nonprod: {
    Auth: {
      region: "us-east-1",
      userPoolId: "us-east-1_hUunAVTyM",
      userPoolWebClientId: "",
      userPoolWebClientIdOpts: {
        atc: "1i790ldmp9rp8oi951nqlf8rrq",
        kbb: "q4u1o2h5f8eltsge966g3mn8o",
      },
      oauth: {
        domain: "test-auth.kbb-autotrader.com",
        redirectSignIn: "https://test.autotrader.com",
        redirectSignOut: "https://test.autotrader.com",
        responseType: "code",
      },
    },
    apiKey: "DqSk2wp7eO7vj81zBU1NG2mK7riJlzIv8qQQdj1a",
  },
  prod: {
    Auth: {
      region: "us-east-1",
      userPoolId: "us-east-1_ajilIwpz2",
      userPoolWebClientId: "",
      userPoolWebClientIdOpts: {
        atc: "4ld47ibr38nvrk1lg0ducu5npn",
        kbb: "46u8n0cjg7vd04uu91a8ubjao4",
      },
      oauth: {
        domain: "auth.kbb-autotrader.com",
        redirectSignIn: "https://www.autotrader.com",
        redirectSignOut: "https://www.autotrader.com",
        responseType: "code",
      },
    },
    apiKey: "xf75twokXo6GMt99pkZNu4wF0XzjqWnj9TSQl9sU",
  },
};

const config = {
  local: {
    atcBaseUrl: ATC_BASE_URL,
    kbbBaseUrl: KBB_BASE_URL,
    apiBaseUrl: API_BASE_URL,
    isProd: false,
    consumerApikey: consumerConfigs["nonprod"],
    consumerApiUrl: isATC ? ATC_BASE_URL + CONSUMER_API_PATH : KBB_BASE_URL + CONSUMER_API_PATH,
    userFraudApiUrl: `https://psx-lact-api-main.awscsprivatesellernp.autotrader.com/api/psx-lact/user/fraud`,
    psxUserWebBaseUrl: "https://static.kbb.com/psx-user-web/main/nonprod/9192239",
    nativeAppEventName: NATIVE_APP_EVENT_NAME,
    enableNewTestDrive: true,
    useOfferDomain: true,
    enableSmsOptInForm: true,
    isOfferDomain: hasOfferDomainPath
  },
  nonprod: {
    atcBaseUrl: ATC_BASE_URL,
    kbbBaseUrl: KBB_BASE_URL,
    apiBaseUrl: API_BASE_URL,
    isProd: false,
    consumerApikey: consumerConfigs["nonprod"],
    consumerApiUrl: isATC ? ATC_BASE_URL + CONSUMER_API_PATH : KBB_BASE_URL + CONSUMER_API_PATH,
    userFraudApiUrl: `${API_BASE_URL}/api/psx-lact/user/fraud`,
    psxUserWebBaseUrl: "https://static.kbb.com/psx-user-web/main/nonprod/9192239",
    nativeAppEventName: NATIVE_APP_EVENT_NAME,
    enableNewTestDrive: true,
    useOfferDomain: true,
    enableSmsOptInForm: true,
    isOfferDomain: hasOfferDomainPath
  },
  prod: {
    atcBaseUrl: ATC_BASE_URL,
    kbbBaseUrl: KBB_BASE_URL,
    apiBaseUrl: API_BASE_URL,
    isProd: true,
    consumerApikey: consumerConfigs["prod"],
    consumerApiUrl: isATC ? ATC_BASE_URL + CONSUMER_API_PATH : KBB_BASE_URL + CONSUMER_API_PATH,
    userFraudApiUrl: `${API_BASE_URL}/api/psx-lact/user/fraud`,
    psxUserWebBaseUrl: "https://static.kbb.com/psx-user-web/main/prod/9192239",
    nativeAppEventName: NATIVE_APP_EVENT_NAME,
    enableNewTestDrive: true,
    useOfferDomain: false,
    enableSmsOptInForm: false,
    isOfferDomain: hasOfferDomainPath
  },
};

export const { psxUserWebBaseUrl, isProd, atcBaseUrl, kbbBaseUrl, apiBaseUrl, atcBaseApiUrl, consumerApikey, consumerApiUrl, userFraudApiUrl, nativeAppEventName, enableNewTestDrive, useOfferDomain, enableSmsOptInForm, isOfferDomain } = config[envConfig];
